exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".break-row[data-v-4562cd81]{white-space:pre-wrap;word-wrap:break-word}", ""]);

// exports
